import { Pagination } from '@packages/toolbox/dist/declarations/pagination';
import { AxiosInstance, AxiosResponse, AxiosStatic } from 'axios';
import { http } from 'SharedDir/backend/axios/http';

import NOTIFICATION from 'SharedDir/backend/endpoints/notification';
import { NNotification } from 'SharedDir/declarations/notification';

export type Filters = {
  unreadOnly: boolean;
  page: number;
  rowsPerPage: number;
  totalCount?: number;
};

export type FilterValue = { filter: string | null };

// eslint-disable-next-line max-len
export const paginationParamsAllRecordsWithFilter: Pagination.PaginationAndFilterParams<FilterValue> =
  {
    page: 1,
    rowsPerPage: null,
    rowsNumber: 0,
    showDeleted: false,
    filter: null,
  };

export const filtersUnread: Filters = {
  unreadOnly: true,
  page: 1,
  rowsPerPage: 20,
};

export const filtersWithPagination = {
  ...paginationParamsAllRecordsWithFilter,
  ...filtersUnread,
};

// eslint-disable-next-line max-len
export type PaginationListWithFilters = Pagination.PaginationAndFilterParams<Filters>;

export type NotificationResponse = Pagination.PaginationParamsOut<
  Filters & {
    messages: NNotification.NotificationList;
    totalCount: number;
  }
>;

export type NotificationTemplateResponseQueryParams = Pagination.PaginationParamsOut<Filters>;

export default class NotificationApiClass {
  /**
   * Получить массив записей
   *
   * @param paginationParams
   * @returns
   */
  public static async getList(
    paginationParams: PaginationListWithFilters
  ): Promise<NotificationResponse> {
    const { data }: AxiosResponse<NotificationResponse> = await http({
      ...NOTIFICATION.LIST,
      params: paginationParams,
      headers: {
        interceptors: false,
      },
    });

    return data;
  }

  /**
   * Получить определенное сообщение
   *
   * @param data
   * @returns
   */
  public static async get(id: string): Promise<NNotification.Notification> {
    const responseData: NNotification.Notification = await http({
      ...NOTIFICATION.GET(id),
    }).then((r): NNotification.Notification => r.data);

    return responseData;
  }

  /**
   * Отметить как прочитанное массив сообщений
   *
   * @param data
   * @returns
   */
  public static async markRead(
    data: NNotification.NotificationUidList
  ): Promise<NNotification.Notification> {
    const responseData: NNotification.Notification = await http({
      ...NOTIFICATION.MARK_READ,
      data: { messages: data },
    }).then((r): NNotification.Notification => r.data);

    return responseData;
  }

  /**
   * Отметить все уведомления как прочитанные
   *
   * @param data
   * @returns
   */
  public static async markAllRead(): Promise<NNotification.Notification> {
    const responseData: NNotification.Notification = await http({
      ...NOTIFICATION.MARK_ALL_READ,
    }).then((r): NNotification.Notification => r.data);

    return responseData;
  }

  /**
   * Зарегистрировать подписку на уведомления
   *
   * @param data
   * @returns
   */
  public async sendSubscription(subscriptionOptions) {
    return http({
      ...NOTIFICATION.REGISTER_SUBSCRIPTION,
      data: subscriptionOptions,
    });
  }
}
